import React from "react";
import {Row} from "reactstrap";
import DateUtils from "../../../../../../core/services/date-utils";

const TimeBubble = ({data}) => {

    return (
        <Row
            id={`${data.submitDateTime}-${data.typeID}-time`}
            className={'w-100 no-gutters align-items-center justify-content-center my-4'}
        >
            <p className={'text-center text-xs text-color-3'}>
                {data.data ? DateUtils.serverToLocal(data.data).format(DateUtils.dateFormatAlternative) : '--'}
            </p>
        </Row>
    );
}

export default TimeBubble;
